import {SECOND} from '../CONST';

export class TimeoutError extends Error {
    constructor(ms: number = 0, msg: string = '') {
        const errorMessage = `Timeout${ms ? ` after ${Math.round(ms / SECOND)} seconds` : ``}. ${msg}`;
        super(errorMessage.trim());
    }
}
